import React from "react";
import connect from "../../Assets/Images/connect.png";
import Button from "../Inputs/Button";

const Connect = () => {
  return (
    <div className="w-full bg-[#FFF] flex-col sm:flex-row gap-6 flex-wrap pt-10 pb-14 flex ">
      <div className="flex-1 pl-[8%] flex flex-col justify-center">
        <h3 className="font-[600] max-w-[90%] sm:max-w-[513px] text-[20px] sm:text-[60px] text-[#000]  sm:leading-[74px] ">
          Be Part Of Our Business
        </h3>
        <h4 className="font-[400] max-w-[90%]   sm:max-w-[513px] text-[14px] sm:text-[19.2px] my-3 sm:mt-4 sm:mb-16 text-[#000] sm:leading-[29px] ">
          If you're interested in our products, please click the button below to
          get in touch with us.
        </h4>
        <Button
          type={"link"}
          link={"mailto:info.greengatepharma@gmail.com"}
          title={"Contact Us"}
        />
      </div>

      <div className="flex-1 items-center sm:items-end justify-center sm:justify-end flex">
        <img
          src={connect}
          alt=""
          className="max-h-[45vh] w-full sm:min-w-[554px] min-h-[45vh] object-cover"
        />
      </div>
    </div>
  );
};

export default Connect;
